import * as React from "react"
const Bread = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <mask
      id="bread"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}>
      <path fill="#E5E5E5" stroke="#73AF3C" d="M.5.5h31v31H.5z" />
    </mask>
    <g mask="url(#bread)">
      <path
        fill="#FFEA9F"
        d="m22.593 26.034-13.91 3.727a1 1 0 0 1-1.225-.707l-2.204-8.226C1.21 19.35.592 8.874 10.24 9.491c10.61-6.686 13.618 3.79 10.855 7.092L23.3 24.81a1 1 0 0 1-.707 1.225Z"
      />
      <path
        stroke="#010101"
        strokeWidth={2}
        d="m20.33 15.941-.334.4.134.501 2.204 8.226-13.91 3.727L6.22 20.57l-.135-.502-.488-.178c-.66-.241-1.29-.9-1.7-1.917a6.097 6.097 0 0 1-.304-3.402c.232-1.16.818-2.224 1.826-2.973 1.006-.748 2.527-1.251 4.758-1.108l.323.02.274-.172c2.546-1.605 4.518-2.103 5.974-2.024 1.425.077 2.45.71 3.15 1.598.718.91 1.11 2.11 1.16 3.275.053 1.183-.248 2.181-.729 2.755Z"
      />
      <path
        fill="#FFEA9F"
        d="m20.733 23.774-12.472-7.2a1 1 0 0 1-.366-1.366l4.258-7.375c-1.814-3.905 5.156-11.75 11.543-4.49 12.23 2.775 6.95 12.309 2.66 12.69L22.1 23.408a1 1 0 0 1-1.366.366Z"
      />
      <path
        stroke="#010101"
        strokeWidth={2}
        d="m26.268 15.037-.517.046-.26.45-4.258 7.376L8.76 15.707l4.258-7.375.26-.45-.219-.472c-.296-.636-.275-1.548.153-2.556a6.098 6.098 0 0 1 2.19-2.622c.985-.655 2.152-.994 3.394-.811 1.24.182 2.672.903 4.149 2.58l.213.244.316.071c2.935.666 4.682 1.708 5.655 2.793.954 1.063 1.23 2.236 1.098 3.359-.136 1.15-.708 2.275-1.495 3.136-.8.873-1.719 1.366-2.465 1.432Z"
      />
      <rect width={2} height={2} x={18} y={6} fill="#010101" rx={1} />
      <rect width={2} height={2} x={10} y={23} fill="#010101" rx={1} />
      <rect width={2} height={2} x={13} y={19} fill="#010101" rx={1} />
      <rect width={2} height={2} x={7} y={15} fill="#010101" rx={1} />
      <rect width={2} height={2} x={20} y={13} fill="#010101" rx={1} />
      <rect width={2} height={2} x={15} y={13} fill="#010101" rx={1} />
    </g>
  </svg>
)
export default Bread
